/**
 * Utility functions for enhanced analytics
 */

// Track user interaction events
export const trackEvent = (category, action, label, value) => {
  if (window.gtag && process.env.NODE_ENV === 'production') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('Form', 'Submission', formName);
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  trackEvent('Button', 'Click', buttonName);
};

// Track service category selection
export const trackServiceCategorySelection = (category) => {
  trackEvent('Service', 'Category Selection', category);
};

// Track outbound links
export const trackOutboundLink = (url) => {
  trackEvent('Outbound', 'Click', url);
  
  // If it's an external link that opens in the same window, delay navigation slightly
  // to ensure the event is tracked
  return true;
};

// Track file downloads
export const trackDownload = (fileUrl, fileName) => {
  trackEvent('Download', 'Click', fileName || fileUrl);
};

// Track time spent on page
export const initTimeTracking = () => {
  if (process.env.NODE_ENV !== 'production') return;
  
  let startTime = new Date();
  
  const recordTimeOnPage = () => {
    const endTime = new Date();
    const timeSpent = Math.round((endTime - startTime) / 1000); // in seconds
    
    if (timeSpent > 10) { // Only track if spent more than 10 seconds
      trackEvent('Engagement', 'Time on Page', window.location.pathname, timeSpent);
    }
  };
  
  // Record when user leaves the page
  window.addEventListener('beforeunload', recordTimeOnPage);
  
  // Record when user navigates within the app
  return () => {
    recordTimeOnPage();
    window.removeEventListener('beforeunload', recordTimeOnPage);
  };
};